<template>
  <v-footer color="primary">
    <v-row justify="center" no-gutters>
      <!-- Links de Texto -->
      <v-btn v-for="link in links" :key="link.text" :href="link.href" color="white" variant="text" class="mx-2"
        rounded="xl" aria-label="Ir a link.text">
        {{ link.text }}
      </v-btn>
      <v-col class="text-center mt-4" cols="12" md="10">
        <v-row>
          <v-col>
            <v-img href='https://www.vallhebron.com/' target="_blank" rel="noopener" class="mx-4" :height="50"
              :src="require('../assets/campus_white.png')"></v-img>
          </v-col>
          <v-col>
            <v-img href='https://www.vallhebron.com/' target="_blank" rel="noopener" class="mx-4" :height="70"
              :src="require('../assets/vhir-negatiu-footer.svg')"></v-img>
          </v-col>
          <v-col>
            <v-img href='https://www.upf.edu/' target="_blank" rel="noopener" class="mx-4" :height="50"
              :src="require('../assets/marcaUPF_negatiu.png')"></v-img>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="text-center mt-4" cols="12">
        {{ new Date().getFullYear() }} — www.embryoscanner.com
        <p>© FIR-HUVH Fundació Institut de Recerca Hospital Universitari Vall d'Hebron</p>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

const { t } = useI18n();
// Ensure translations update reactively
const translatedHome = computed(() => t('Home'));
const translatedContacto = computed(() => t('Contacto'));
const translatedPolitica = computed(() => t('Política_de_protección_de_datos'));

const links = [
  { text: translatedHome, href: '/' },
  { text: translatedContacto, href: 'mailto:alba.farras@vallhebron.cat' },
  {
    text: translatedPolitica,
    href: 'https://www.vallhebron.com/politica-de-proteccio-de-dades',
  },
];
</script>